<template>
  <main class="content login">
      <section class="heading has-padding">
        <h1>Anmeldung</h1>
      </section>

      <section class="form has-padding">
            <div class="field">
                <label class="label">Benutzer</label>
                <div class="control has-icons-right">
                    <input class="input" type="email" placeholder="Benutzername" v-model="credentials.userName">
                    <span class="icon is-flex is-right">
                        <i class="fas fa-user fa-xs"></i>
                    </span>
                </div>
            </div>

            <div class="field">
                <label class="label">Passwort</label>
                <div class="control has-icons-right">
                    <input class="input" type="password" placeholder="Password" v-model="credentials.password">
                    <span class="icon is-flex is-right">
                        <i class="fas fa-password fa-xs"></i>
                    </span>
                </div>
            </div>

            <div v-if="show_ErrorDialog" class="error-msg">
                <p><strong>Hinweis:</strong> Der Benutzername bzw. das Passwort wurden leider nicht gefunden.</p>
            </div>
      </section>

      <div @click="fetch_POST_Login()" class="button is-primary is-flex">
          <h3>Anmelden</h3>
      </div>
  </main>
</template>

<script>
// @ is an alias to /src
// import Header from '@/components/Header.vue'
import axios from 'axios';

export default {
  name: 'login',
  data() {
    return {
        credentials: {
            userName: '',
            password: ''
        },
        show_ErrorDialog: false
    }
  },
  methods: {
    goToPath (route) {
        this.$router.push(route);
    },
    fetch_POST_Login () {
        axios.post('https://www.lola-inspect.at/api/login', this.credentials)
        .then(function (response) {
            this.show_ErrorDialog = false
            this.$store.commit('updateCredentials', response.data);
            this.goToPath('inspektionen');
        }.bind(this))
        .catch(function (error) {
            this.show_ErrorDialog = true
            console.log(error);
        }.bind(this));
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.login {
    margin-top: calc(50vh - 220px);

    h1 {
        padding-bottom: 1rem;
    }
}

.control {
    position: relative;
}

.icon {
    position: absolute;
    width: 50px;
    height: 100%;
    right: 0;
    top: 0;
    pointer-events: none;
}

.fa-user {
    width: 34%;
    height: 34%;
    background-image: url('../assets/lnr-user.svg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: block;
}

.fa-password {
    width: 39%;
    height: 39%;
    background-image: url('../assets/lnr-lock.svg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    display: block;
}

@media all and (min-width: 640px) and (max-width: 1100px) {

}

@media (min-width: 780px) {
  .list-entry .icon {
    right: calc(var(--padding) - 20px);
  }

  .has-padding {
    max-width: var(--maxWidth);
    margin: 0 auto;
  }
}
</style>
